import axios from 'axios'
import { MessageBox } from 'element-ui'
import { message } from './resetMessage'
import store from '@/store'
import { getToken } from '@/utils/auth'
import configs from '../../vue.config'
import router from '@/router'
const service = axios.create({
	baseURL: process.env.VUE_APP_BASE_API,
	timeout: 600 * 1000
})

service.interceptors.request.use(
	(config) => {
		const token = getToken()
		if (token) {
			config.headers['user-token'] = token
		} else {
			config.headers['user-token'] = ''
		}
		return config
	},
	(error) => {
		return Promise.reject(error)
	}
)
service.interceptors.response.use(
	(response) => {
		if (response.data.code === '-202') {
			MessageBox.alert('您的账号已在其他设备登录，请重新登录', '账号已下线', {
				confirmButtonText: '重新登录',
				showClose: false,
				type: 'warning',
				callback: () => {
					store.dispatch('user/resetToken').then(() => {
						if (configs.pagesLogin === 'hash') {
							router.push('/#/login')
						} else {
							router.push('/login')
						}
						location.reload()
					})
				}
			})
			return Promise.reject('账号已下线')
		}
		const res = response

		return res
	},
	(error) => {
		return Promise.reject(error)
	}
)

export default service
